/* @flow */

import { compose } from 'ramda';
import * as React from 'react';

import SignupAboutSection from './about/SignupAboutSection';
import SignupAvatarSection from './avatar/SignupAvatarSection';

type Props = {
  isAvatarShown: boolean,
  handleAboutSubmit: (Object) => void,
  handleAvatarSubmit: () => void,
  handleAvatarBack: () => void,
};

const SignupProfileWizardDumb = ({
  isAvatarShown,
  handleAboutSubmit,
  handleAvatarSubmit,
  handleAvatarBack,
}: Props): React.Node => {
  if (isAvatarShown) {
    return (
      <SignupAvatarSection
        handleSubmit={handleAvatarSubmit}
        handleBack={handleAvatarBack}
      />
    );
  }

  return <SignupAboutSection handleSubmit={handleAboutSubmit} />;
};

export default compose(React.memo)(SignupProfileWizardDumb);
